<template>
    <div id="app">
        <router-view class="app-box" :isMobile="isMobile" :cdnPrefix="cdnPrefix" />

        <div v-show="show_maker" @click="toTop" class="marker">
            <img :src="cdnPrefix + '/imgs/marker.png'" alt />
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            isMobile: document.body.offsetWidth <= 768 ? true : false,
            show_maker: false,
            cdnPrefix: "https://cdn-os-web.jedi-games.com/gw/games/sengoku/static"
        };
    },
    watch: {
        $route(to, from) {
            document.querySelector(".app-box").scrollTo(0, 0);
        }
    },
    mounted() {
        document.querySelector(".app-box").scrollTo(0, 0);
        this.htmlBasicsSetting();
        // 追踪链接
        this.handleTrace();
        document.querySelector(".app-box").onscroll = this.handleOnScroll;
        document.querySelector(".app-box").onresize = this.handleOnResize;
    },
    methods: {
        // 基础设置
        htmlBasicsSetting() {
            // 页面基础字体
            let winW = document.documentElement.clientWidth,
                desW = 1900,
                htmlFont = (winW / desW) * 16;
            if (winW > 768) {
                window.htmlFont = htmlFont;
                document.documentElement.style.fontSize = htmlFont + "px";
            } else {
                document.documentElement.style.fontSize = "14px";
            }

            // 页面title
            let lang = window.localStorage.getItem("localeLanguage");
            let apptitle = "";
            if (lang == "ja") {
                apptitle = "戦国布武~我が天下戦国編～公式サイト";
            } else if (lang == "en") {
                apptitle = "Sengoku Fubu";
            } else if (lang == "th") {
                apptitle = "Sengoku Fubu";
            } else {
                apptitle = "戰國布武";
            }
            document.title = apptitle;
        },
        // 追踪链接
        handleTrace() {
            let webname = this.GetUrlParam("trace");
            if (webname) {
                let clickFreq = sessionStorage.getItem("jedi_p20n");
                if (!clickFreq) {
                    this.getClickFreq(webname);
                }
                sessionStorage.setItem("jedi_p20n", webname);
            }
        },
        getClickFreq(webname) {
            $.ajax({
                url: "./api/data.php",
                type: "post",
                async: true,
                data: {
                    func: "getClickFreq",
                    webname: webname
                },
                success: function(data, status) {}
            });
        },
        GetUrlParam(paraName) {
            var url = document.location.toString();
            var arrObj = url.split("?");
            if (arrObj.length > 1) {
                var arrPara = arrObj[1].split("&");
                var arr;
                for (var i = 0; i < arrPara.length; i++) {
                    arr = arrPara[i].split("=");

                    if (arr != null && arr[0] == paraName) {
                        return arr[1];
                    }
                }
                return "";
            } else {
                return "";
            }
        },
        handleOnScroll(e) {
            let scrollTop = document.querySelector(".app-box").scrollTop;
            // console.log(scrollTop);
            this.show_maker = scrollTop >= 200 ? true : false;
        },
        handleOnResize(e) {
            this.isMobile = document.body.offsetWidth <= 768 ? true : false;
        },
        toTop() {
            document.querySelector(".app-box").scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
};
</script>

<style lang="scss">
@keyframes animate_bounce_maker {
    0% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(20px);
    }
    100% {
        transform: translateY(0px);
    }
}
#app {
    height: 100%;
    .marker {
        z-index: 1000;
        cursor: pointer;
        position: fixed;
        bottom: 20px;
        right: 5%;
        width: 50px;
        animation: "animate_bounce_maker" 1s ease-in-out infinite;
    }
}
// 移动端
@media screen and (max-width: 768px) {
    #app {
        .marker {
            display: none;
        }
    }
}

html,
body {
    height: 100%;
}
ul li {
    list-style: none;
}
a {
    text-decoration: none;
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue